import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Event List", -1)
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Event Actions"
}
const _hoisted_4 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Event actions"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-outline-primary",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#filters",
  "aria-expanded": "false",
  "aria-controls": "filters"
}, " Filters ", -1)
const _hoisted_6 = {
  class: "collapse",
  id: "filters",
  role: "toolbar",
  "aria-label": "Event filters"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "statusFilter"
}, "Status", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "" }, null, -1)
const _hoisted_10 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Filter actions"
}
const _hoisted_11 = { class: "panel" }
const _hoisted_12 = { "aria-label": "Page navigation" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-sm-2" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = {
  key: 0,
  class: "pagination justify-content-center"
}
const _hoisted_17 = {
  key: 1,
  class: "page-link"
}
const _hoisted_18 = { class: "col-sm-2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table table-striped" }
const _hoisted_22 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Source Event"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Employee"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Activity"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Location"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Processing")
  ])
], -1)
const _hoisted_23 = { class: "list-group" }
const _hoisted_24 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList())),
          class: "btn btn-outline-primary"
        }, "Refresh"),
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("select", {
          class: "form-select",
          "aria-label": "Status",
          "aria-describedby": "statusFilter",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestFilter.LatestReceiverStatus = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList()))
        }, [
          _hoisted_9,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions.Status, (item) => {
            return (_openBlock(), _createBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.requestFilter.LatestReceiverStatus]
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("button", {
          class: "btn btn-outline-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getList()))
        }, "Apply"),
        _createVNode("button", {
          class: "btn btn-outline-secondary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearFiltersAndRefresh()))
        }, "Clear")
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("nav", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _withDirectives(_createVNode("select", {
              class: "form-select",
              "aria-label": "Results per page",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestPaging.Limit = $event)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList()))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requestPaging.Options, (item) => {
                return (_openBlock(), _createBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.requestPaging.Limit]
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            (_ctx.pageBounds)
              ? (_openBlock(), _createBlock("ul", _hoisted_16, [
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > _ctx.requestPaging.Limit && _ctx.requestPaging.Skip > 0 ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPage('-1'))),
                      href: "#",
                      tabindex: "-1",
                      "aria-disabled": "true"
                    }, "Previous")
                  ], 2),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageBounds, (page) => {
                    return (_openBlock(), _createBlock("li", {
                      key: page.number,
                      class: ['page-item', page.current == true ? 'active' : '', page.number == 0 ? 'disabled' : '']
                    }, [
                      (page.number > 0)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "page-link",
                            href: "#",
                            onClick: ($event: any) => (_ctx.setPage(page.number))
                          }, _toDisplayString(page.number), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("a", _hoisted_17, "…"))
                    ], 2))
                  }), 128)),
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > (_ctx.requestPaging.Limit + _ctx.requestPaging.Skip) ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setPage('+1')))
                    }, "Next")
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_18, [
            (_ctx.backendResponse.count > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.requestPaging.Skip > 0 ? _ctx.requestPaging.Skip : 1) + " to " + _toDisplayString(Math.min(_ctx.requestPaging.Skip + _ctx.requestPaging.Limit, _ctx.backendResponse.count)) + " of " + _toDisplayString(_ctx.backendResponse.count), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("table", _hoisted_21, [
        _hoisted_22,
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (event) => {
            return (_openBlock(), _createBlock("tr", {
              key: event.id
            }, [
              _createVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: '/receiver/correlation/' + event.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(event.LatestReceiverStatus), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: '/sheqsy/event/' + event.SourceEvent.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(event.SourceEvent.Message), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode("td", null, _toDisplayString(event.SourceEvent.Employee.FirstName) + " " + _toDisplayString(event.SourceEvent.Employee.LastName), 1),
              _createVNode("td", null, _toDisplayString(event.SourceEvent.Activity.Name) + " (" + _toDisplayString(event.SourceEvent.Activity.ActivityType) + ")", 1),
              _createVNode("td", null, _toDisplayString(event.SourceEvent.Latitude) + ", " + _toDisplayString(event.SourceEvent.Longitude), 1),
              _createVNode("td", null, [
                _createVNode("ul", _hoisted_23, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(event.ReceiverAction, (rxaction) => {
                    return (_openBlock(), _createBlock("li", {
                      key: rxaction.id,
                      class: ['list-group-item', 'list-group-item-' + (rxaction.Result ? 'success' : (rxaction.ReceiverStatus == 'unsupported' ? 'warning' : 'danger'))]
                    }, [
                      _createTextVNode(_toDisplayString(rxaction.ReceiverStatus) + " @ " + _toDisplayString(_ctx.getHumanDate(rxaction.Generated)), 1),
                      (rxaction.GeneratedArtefacts > 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_24, " (" + _toDisplayString(rxaction.GeneratedArtefacts) + " signals)", 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}